






















import { Component, Vue } from 'vue-property-decorator';
import '@/component/evaluate/css/card.less';
/**
 *
 */
@Component({
    components: {},
})
export default class DigitalTwins extends Vue {}
